import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

/** Hook to fetch a single site-content section with sensible defaults.
 *  - Returns `defaults` immediately, then merges saved fields when API responds.
 *  - Never blocks render (retry=false, staleTime=2min). */
export function useSiteSection(sectionId, defaults = {}) {
  const { data } = useQuery({
    queryKey: ["siteContent", sectionId],
    queryFn: async () => (await api.get(`/site-content/${sectionId}`)).data,
    staleTime: 2 * 60 * 1000,
    retry: false,
  });
  return { ...defaults, ...(data || {}) };
}
